export default {
  ru: {
    paymentInvoice: 'Счет на оплату'
  },

  en: {
    paymentInvoice: 'Payment invoice'
  }
}